import { categoryBasePath, basePath, casestudyTypes } from '@constants';

export { basePath };
export { interviewBasePath, categoryBasePath } from '@constants';

export const isBasePath = (path: string) =>
  path === basePath || path === `${basePath}/`;
export const blogBasePath = `${basePath}/blog`;
export const categoryPath = (categorySlug?: string | null) =>
  `${categoryBasePath}/${categorySlug || ''}`;
export const postPath = (slug: string, customPath = 'blog') =>
  `${basePath}/${customPath}/${slug}`;
export const hnaviCategoryPath = (category: string) => `/${category}`;
export const hnaviCasePath = (categoryCode: string) => `/${categoryCode}/case`;
export const hnaviCorporationPath = '/corporation';
export const hnaviSearchPath = (key?: string) =>
  key ? `/corporation/${key.replaceAll('-slash-', '/')}/` : '/search';
export const casestudyListPath = (
  casestudyType: keyof typeof casestudyTypes | null = 'casestudy',
  hnaviCategory?: string | null
) => (hnaviCategory ? `/${hnaviCategory}` : basePath) + `/${casestudyType}`;
export const featurePostListPath = (hnaviCategory: string) =>
  `/${hnaviCategory}/feature`;
export const developerEntryPath = '/ad/';
export const adSaasPath = '/ad-saas/';
export const beginnersPath = '/guide/';
export const buyerContactPath = '/other/contact/';
export const tosPath = '/tos/';
export const privacyPolicyPath = '/privacy/';
